import * as type from './types';

export function registerOtp(data) {
  return {
    type: type.POST_REGISTER_OTP_REQUESTED,
    data: data,
  }
}

export function clearRegisterOtpError() {
  return {
    type: type.CLEAR_REGISTER_OTP_ERROR
  }
}